import { atom } from 'recoil'

export const isOpenContractDetailsState = atom({
  key: 'isOpenContractDetailsState',
  default: false
})
